import { AlertTriangle } from "lucide-react";
import { Nav } from "./Nav";
import { Footer } from "./Footer";

export function LegalLayout({ title, updated, children, testId }) {
  return (
    <div>
      <Nav />
      <main className="container-x max-w-3xl pb-24 pt-32" data-testid={testId}>
        <p className="eyebrow">Legal</p>
        <h1 className="mt-4 text-4xl sm:text-5xl font-semibold tracking-[-0.035em] text-white">{title}</h1>
        <p className="mt-3 text-sm text-slate-400">Effective date: {updated}</p>
        <div className="mt-8 flex gap-3 rounded-2xl border border-amber-300/25 bg-amber-300/[0.06] p-4 text-sm text-amber-100" role="note" data-testid="legal-review-notice">
          <AlertTriangle className="h-5 w-5 shrink-0 text-amber-300" />
          <p>Draft for review. This page contains placeholders in [brackets] and must be reviewed by qualified legal counsel before launch. It is not represented as legally approved.</p>
        </div>
        <div className="legal mt-10 space-y-8 text-[15px] leading-relaxed text-slate-300 [&_h2]:mb-3 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-white [&_li]:ml-5 [&_li]:list-disc [&_ul]:space-y-1.5">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export const Ph = ({ children }) => <mark className="rounded bg-amber-300/15 px-1 text-amber-200">{children}</mark>;
